var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWhiteEmail = function SvgWhiteEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    fillRule: "evenodd",
    d: "M10 12.974 0 4.149V15.5h20V4.149zm.001-2.662L0 1.481V.5h20v.981z",
    clipRule: "evenodd"
  })));
};
export { SvgWhiteEmail as ReactComponent };
export default __webpack_public_path__ + "images/white_email.svg";